module.exports = __webpack_public_path__ + "static/img/8.092fcd1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fish/csfish/8.png
// module id = xzYi
// module chunks = 0